export const CZ_TRANSLATION = {
  "COMPANIES_UPDATE_SUCCESS": "Aktualizováno",
		"LIMIT": "Limit",
		"ACCOUNT_ID": "Fakturační účet",
		"SIGNIN": "Přihlásit se",
		"SIGNIN_WELCOME_MESSAGE": "Přihlásit se",
		"SIGNIN_EMAIL": "Email",
		"SIGNIN_PASSWORD": "Heslo",
		"SIGNIN_REMEMBER_ME": "Zapamatuj si mě",
		"SIGNIN_SUBMIT": "Přihlásit se",
		"SIGNIN_FORGOT_PASSWORD": "Zapomněli jste heslo?",
		"SIGNIN_ERROR": "Špatná data",
		"PASSWORD_HEADING": "Obnovit heslo",
		"PASSWORD_EMAIL": "Email",
		"PASSWORD_SUBMIT": "Obnovit heslo",
		"PASSWORD_REQUEST_SUCCESS": "Zkontrolujte e-mail a obnovte heslo",
		"PASSWORD_REQUEST_ERROR": "Něco se pokazilo...",
		"PASSWORD_RESET_SUCCESS": "Vaše heslo bylo změněno, nyní budete přihlášeni",
		"PASSWORD_RESET_ERROR": "Něco se pokazilo..",
		"PASSWORD_NEW_PASSWORD": "Nové heslo",
		"PASSWORD": "Heslo",
		"DASHBOARD": "Náhled",
		"DASHBOARD_HEADING": "Vítejte v aplikaci",
		"GO_TO_DETAIL": "Zobrazit podrobnosti",
		"BOOKING_CROSSING": "Rezervace přepravy",
		"BOOKING_OPERATOR": "Rejdař",
		"BOOKING_RELATION": "Relace",
		"BOOKING_DEPARTURE_DATE": "Datum",
		"BOOKING_DEPARTURE_HOURS": "Hodina",
		"BOOKING_DATA": "Rezervační údaje",
		"BOOKING_VEHICLE": "Údaje o vozidle",
		"BOOKING_LENGTH": "Délka [m]",
		"BOOKING_WEIGHT": "Hmotnost [t]",
		"BOOKING_LIST_RESERVATION_NUMBER": "Rezervace číšlo",
		"BOOKING_LIST_DATE": "Datum",
		"BOOKING_LIST_OPERATOR": "Rejdař",
		"BOOKING_LIST_STATE": "Status",
		"BOOKING_LIST_RELATION": "Relace",
		"BOOKING_LIST_VEHICLE": "Vozidlo",
		"BOOKING_LIST_CONTRACTOR": "Obchodní partner",
		"BOOKING_NUMBER": "Rezervace číšlo",
		"DEPARTURE_DATE": "Datum",
		"BOOKING_STATUS": "Status",
		"ROUTE": "Relace",
		"VEHICLE_NUMBER": "Vozidlo",
		"CONTRACTOR": "Obchodní partner",
		"CREATOR": "Kupující",
		"BOOKING_LIST_WORKING": "Průběžné",
		"BOOKING_LIST_HISTORY": "Historie",
		"BOOKING_LIST_NEW": "Nové",
		"BOOKING_UPDATE_SUCCESS": "Přeprava byla aktualizována",
		"BOOKING_VEHICLE_TYPE": "Typ vozidla",
		"BOOKING_VEHICLE_NUMBER": "Vozidlo číšlo",
		"BOOKING_REF": "Tvoje REF.",
		"REF1": "REF1",
		"BOOKING_CARGO_NUMBER": "Návěs číslo",
		"BOOKING_NUMBER_OF_DRIVERS": "Počet řidičů",
		"BOOKING_DESCRIPTION": "Druh nákladu",
		"BOOKING_CONTRACTOR": "Obchodní partner",
		"BOOKING_LIST_CREATOR": "Kupující",
		"BOOKING_STATUS_MODIFIED": "Upraveno",
		"BOOKING_STATUS_MODIFIED_WAITLIST": "Upraveno - WL",
		"BOOKING_STATUS_DESTROYED": "Odebráno",
	  "BOOKING_STATUS_DESTROYED_PENDING": "Oczekuje na usunięcie",
		"BOOKING_STATUS_WAITING": "Čeká",
	  "BOOKING_STATUS_CONFIRMED": "Confirmed",
	  "BOOKING_STATUS_WAITLIST": "Čeká - WL",
		"BOOKING_STATUS_EXPIRED": "Jeho platnost vypršela",
		"BOOKING_STATUS_SUCCESS": "Dokončeno",
		"BOOKING_STATUS_ERROR": "Chyba",
		"BOOKING_CREATE": "Zarezervujte si přepravu",
		"BOOKING_CREATE_CATCH_LIMIT": "Kvóta pro přepravu byla překročena",
		"BOOKING_CREATE_RETURN": "Zpáteční",
		"EMPTY_VEHICLE": "Prázdné vozidlo",
		"DRIVER_PHONE_NUMBER": "Telefonní číslo řidiče",
		"DRIVER_PHONE_NUMBER_TOOLTIP": "Telefonní číslo pro upozornění SMS",
		"SCANDLINES_DISCLAIMER": "Pozornost! Pokud máte nebezpečný nebo nadrozměrný náklad nebo přepravujete zvířata, zarezervujte si standardní trasu, abyste se vyhnuli dodatečným nákladům.",
		"TUNNEL_DISCLAIMER": "U vozidel s výškou nad 4,05 m hlaste přímo speditérovi. Lze rezervovat pouze pro třídy 5 a 6 a šířky do 2,55 m.",
		"BOOKING_UPDATE_SUBMIT": "Upravit",
		"PLUG_IN": "Chlazení",
		"BOOKING_UPDATE": "Úprava přepravy",
		"BOOKING_SELECT_RELATION": "Vyberte relaci",
		"BOOKING_BOOKING_VALUE": "Hodnota",
		"BOOKING_BOOKING_VALUE_OVERRIDE": "Jiná hodnota",
		"BOOKING_IS_BOOKING_VALUE_OVERRIDE": "Přepsat hotnotu?",
		"BOOKING_PAYMENT_STATUS": "Status platby",
		"BOOKING_LIMIT": "Zbývající limit pro vaši společnost:",
		"BOOKING_LIMIT_WRONG": "Něco se pokazilo",
		"BOOKING_INVOICE_ACCOUNT_ID": "Fakturační účet",
		"USERS_CREATE": "Přidat uživatele",
		"USERS_DATA": "Uživatelská data",
		"USERS_UPDATE_EMAIL": "Email",
		"USERS_UPDATE_FIRSTNAME": "Jméno",
		"USERS_UPDATE_LASTNAME": "Příjmení",
		"USERS_UPDATE_PHONE": "Telefonní číslo",
		"PHONE": "Telefonní číslo",
		"USERS_UPDATE_PASSWORD": "Heslo",
		"USERS_UPDATE_PASSWORD_CONFIRM": "Potvrzení hesla",
		"USERS_UPDATE": "Aktualizujte uživatele",
		"USER_SUSPENDED": "Blokováno",
		"USER_CREATE_SUCCESS": "Uživatel vytvořen",
		"USERS_UPDATE_SUCCESS": "Uživatel aktualizován",
		"FORM_SEARCH_PLACEHOLDER": "Vyhledávání",
		"COMPANIES_CREATE": "Vytvořte společnost",
		"COMPANIES_DATA": "Údaje o společnosti",
		"COMPANIES_USERS": "Uživatelé",
		"APP_SETTINGS": "Nastavení aplikace",
		"FIRSTNAME": "Jméno",
		"LASTNAME": "Příjmení",
		"EMAIL": "Email",
		"POST_CODE": "Směrovací číslo",
		"NAME": "Název",
		"VAT_ID": "DIČ",
		"CUSTOMER_ID": "ID Klienta",
		"SEARCH": "Vyhledávání",
		"STREET": "Ulice",
		"CITY": "Město",
		"COUNTRY": "Země",
		"APP_SETTINGS_UPDATE": "Aktualizujte aplikaci",
		"SETTINGS_UPDATE_SUCCESS": "Údaje aktualizovány",
		"SETTINGS_CREATED_SUCCESS": "Data uložena",
		"SETTINGS_DELETED_SUCCESS": "Data smazána",
		"ADMIN": "Administrační panel",
		"LOGOUT": "Odhlásit se",
		"LINE_ONE": "název",
		"LINE_TWO": "NIP / DIČ",
		"LINE_THREE": "Řádek 3",
		"LINE_FOUR": "Řádek 4",
		"LINE_FIVE": "Řádek 5",
		"UPLOAD_AVATAR_SENDED": "Avatar byl aktualizován",
		"CANCEL": "Zrušit",
		"PACKAGE": "Soubor",
		"OTHER": "Další",
		"ROADTRAIN": "Road Train or longer",
		"CAR": "Osobní automobil",
		"CCHNEW": "Autokar",
		"CON": "Kontejner",
		"EXCVAN": "Karavan",
		"GLASS": "Auto se stojanem na převoz oken",
		"HBOX": "Auto s přívěsem pro koně",
		"LORRY": "Vozík",
		"LT": "Sklápěč s návěsem",
		"ST": "Tahač",
		"STKR": "Cisterna",
		"TT": "Zestaw",
		"TTKR": "Cisterna",
		"UNIT": "Tirák",
		"VAN": "Dodávka",
		"VANTLR": "Dodávka s přívěsem",
		"CONFIRM_DESTROY_RECORD": "Opravdu chcete záznam smazat?",
		"DESTROY_RECORD": "Vymazat",
		"UPDATE": "Uložit",
		"ADD": "Přidat",
		"NEW": "Nový",
		"HISTORY_BACK_BUTTON": "Zpět",
		"EMPTY_PAGE": "Nejsou žádné záznamy k zobrazení",
		"NOTFOUND": "Na uvedené adrese jsme nic nenašli",
		"UNAUTHORIZED": "Vaše relace vypršela",
		"FORBIDDEN": "K uvedenému zdroji nelze získat přístup",
		"NONE": "Žádná data",
		"PARTIAL": "Částečně",
		"FULL": "Zaplaceno",
		"ADMIN_BOOKING_LIST": "Seznam přejezdů",
		"BOOKING_MULTI_TITLE": "Rezervace přepravy",
		"BOOKING_MULTI_ROUTE": "Trasa",
		"BOOKING_MULTI_DATE": "Datum",
	  "BOOKING_MULTI_TIME": "Hodina",
		"BOOKING_MULTI_REF": "Tvoje REF",
		"BOOKING_MULTI_VEHICLE_TYPE": "Typ vozidla",
		"BOOKING_MULTI_VEHICLE_WIDTH": "Délka",
		"BOOKING_MULTI_WEIGHT": "Váha",
		"BOOKING_MULTI_VEHICLE_PLATE": "Číslo",
		"BOOKING_MULTI_TRAILER_PLATE": "Návěs",
		"BOOKING_MULTI_CANCEL": "Smazat",
		"BOOKING_MULTI_BOOK": "Rezervace",
		"BOOKING_MULTIPLY": "Vícenásobná přeprava",
		"BOOKING_NO_OF_BOOKINGS": "Počet přejezdů",
		"AR": "Artic 16,5m",
		"CB": "Tahač",
		"CT": "Odtahovka",
		"DT": "Přívěs",
		"HB": "Přívěs pro koně",
		"RD": "Lorra/Van",
		"RT": "Road Train 18m",
		"PRINT_DOC": "potvrzení",
		"AGREEMENT_TITLE": "Souhlas",
		"AGREEMENT_DESC": "Přečtěte si prosím následující souhlasy a vyberte všechny.",
		"AGREEMENT_CHECK_ALL": "Vybrat vše",
		"AGREEMENT_TANDC": "Prohlašuji, že jsem si přečetl podmínky použití – dostupné na webových stránkách <a href=\"https://www.promyskat.pl/regulamin-serwisu\" target=\"_blank\"> Předpisy </a> a souhlasím se všemi obsaženými v <br> Správcem Vašich osobních údajů je: SKAT Transport P.S.A. se sídlem v Gdaňsku.",
		"AGREEMENT_PRIVACY": "Jak zpracováváme vaše osobní údaje, naleznete v našich <a href=\"https://www.promyskat.com/promyskat.pl/privacy-policy\" target=\"_blank\"> Zásadách ochrany osobních údajů</a> dostupných na adrese: Ochrana osobních údajů Politika",
		"AGREEMENT_PRIVACY2": "Prohlašuji, že jsem si přečetl <a href=\"https://www.promyskat.pl/promyskat.pl/privacy-policy\" target=\"_blank\"> Zásady ochrany osobních údajů</a>",
		"AGREEMENT_CONFIRM": "Poslat",
		"BOOKING_QUEUE_RESET": "Smazat seznam",
		"WAITING_FOR_BOOKINGS": "Čekání na novou rezervaci",
		"SPEDITOR_MODE": "Dopravce",
		"STANDARD_MODE": "Standard",
    "MANAGER_MODE": "Manager",
		"CUSTOMER": "Klient",
		"SMS_NOTIFICATION": "SMS upozornění",
		"LANG": "Jazyk",
		"ERROR_NO_SPEDITOR_ID": "Žádná konfigurace přeposílání",
		"USERS_SPEDITOR_ID": "ID spedytora",
		"ATTACHMENT": "Załącznik",
	  "BPP": "Truck Trailer",
	  "BPO": "Lorry",
	  "TE": "Trailer",
	  "CH": "Chassis",
		"UPLOAD_VEHICLES": "Vehicles configuration",
		"UPLOAD": "Upload",
		"DELETE": "Delete",
		"SAVE": "Save",
		"UPLOADED_VEHICLES_CREATED_SUCCESS": "Changes saved",
		"UPLOADED_VEHICLES_BAD_FILE": "Incorrect file",
	  "ADR_INFO": "UN, grupa i klasa",
		"FGTVAN": "FGTVAN",
	 "OVERSIZED": "Oversize",
   "BOOKING_OVERSIZED_WIDTH": "Width [m]",
	 "BOOKING_OVERSIZED_HEIGHT": "Height [m]",
	 "BOOKING_OVERSIZED_WEIGHT": "Weight [t]",
	 "ACCOUNT_MANAGER": "Account manager",
	 "BOOKING_ADMIN": "Booking Admin",
	 "ADD_FILE": "Add File",
   "CLEAR_FILE": "Remove",
	 "ADR_DECLARATION": "ADR Declaration",
   "ADR_DISCLAIMER": "A Dangerous Goods Declaration must be provided. You can attach it below.",
		"SEMITRAILER": "Semi Trailer",
		"TRUCKTRAILER": "Truck Trailer",
    "ARTIC": "Artic",
	  "TRAILER": "Naczepa",
		"VEHICLE": "Pojazd",
	  "TANKER": "Cysterna",
	  "TRACTOR": "Ciągnik",
	  "AFTERHOURS_TITLE": "Ważna informacja",
	  "AFTERHOURS_DESC": "Rezerwacja nie została zmieniona ani anulowana.\nUprzejmie prosimy o kontakt z numerem dyżurnym w celu uzyskania dalszych informacji.",
	  "AFTERHOURS_PHONE": "+48 532 773 112",
    "AFTERHOURS_CONFIRM": "Rozumiem"
}


/** WEBPACK FOOTER **
 ** ./frontend/components/translates/cz.const.js
 **/